import { render } from "./ImpersonateView.vue?vue&type=template&id=60605609"
import script from "./ImpersonateView.vue?vue&type=script&lang=js"
export * from "./ImpersonateView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alejandrobernal/Documents/fbc/fbc-ecommerce-main-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__